import {useEffect, useState} from 'react';
import dayjs from 'dayjs';
import Select from 'react-select';
import {Redirect} from 'react-router-dom';

import styles from './styles.module.css';

import http from 'services/http';
import {alerta} from "../../../components/Alert";
import ValoresDescarga from '../Descarga/ValoresDescarga';

export default function DescargaAutomatica() {
    const [data, setData] = useState(dayjs().format('YYYY-MM-DD'));
    const [dataBRL, setDataBRL] = useState(dayjs(data).format('DD/MM/YYYY'));
    const [loterias, setLoterias] = useState([]);
    const [loteria, setLoteria] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingGerar, setLoadingGerar] = useState(false);
    const [relatorio, setRelatorio] = useState([]);
    const [historico, setHistorico] = useState([]);
    const [totalGerado, setTotalGerado] = useState('0,00');
    const [totalPendente, setTotalPendente] = useState('0,00');
    const [hasNoResult, setHasNoResult] = useState(false);
    const [activeTab, setActiveTab] = useState('valores');
    const [bancaInfo, setBancaInfo] = useState(null);
    const [sumario, setSumario] = useState(null);
    const [redirectTo, setRedirectTo] = useState(null);
    const [ehOrigem, setEhOrigem] = useState(false);
    const [ehDestino, setEhDestino] = useState(false);
    const [recebidas, setRecebidas] = useState({itens: [], total: '0,00', quantidade: 0});
    const [filtroPalpite, setFiltroPalpite] = useState('');

    // Filtra por número do palpite (substring) e ordena por número
    const aplicarFiltroEOrdenar = (lista) => {
        const filtrada = filtroPalpite
            ? lista.filter(item => String(item.numero ?? '').includes(filtroPalpite))
            : lista;
        return [...filtrada].sort((a, b) => String(a.numero ?? '').localeCompare(String(b.numero ?? ''), undefined, {numeric: true}));
    };
    const [dataInicioRecebidas, setDataInicioRecebidas] = useState(dayjs().format('YYYY-MM-DD'));
    const [dataFimRecebidas, setDataFimRecebidas] = useState(dayjs().format('YYYY-MM-DD'));
    const [loadingRecebidas, setLoadingRecebidas] = useState(false);
    const [loteriaFiltroRecebidas, setLoteriaFiltroRecebidas] = useState('');
    const [bancaOrigemFiltroRecebidas, setBancaOrigemFiltroRecebidas] = useState('');
    const [loteriasRecebidas, setLoteriasRecebidas] = useState([]);
    const [bancasOrigemRecebidas, setBancasOrigemRecebidas] = useState([]);

    // Mapeia o dia da semana para o campo correspondente na loteria
    const mapDiaSemana = {
        0: 'domingo',
        1: 'segunda',
        2: 'terca',
        3: 'quarta',
        4: 'quinta',
        5: 'sexta',
        6: 'sabado'
    };

    const [todasLoterias, setTodasLoterias] = useState([]);

    async function requestLoterias() {
        try {
            const response = await http.get('/loterias', {params: {todas: 1}});

            const loteriasLista = response.data.data.map((loteriaItem) => {
                return {
                    value: loteriaItem.id,
                    label: loteriaItem.nome,
                    ativo: loteriaItem.ativo,
                    domingo: loteriaItem.domingo,
                    segunda: loteriaItem.segunda,
                    terca: loteriaItem.terca,
                    quarta: loteriaItem.quarta,
                    quinta: loteriaItem.quinta,
                    sexta: loteriaItem.sexta,
                    sabado: loteriaItem.sabado,
                };
            });

            setTodasLoterias(loteriasLista.filter(el => el.ativo === true));
        } catch (e) {
            alerta(e.response?.data)
        }
    }

    // Filtra loterias pelo dia da semana da data selecionada
    function filtrarLoteriasPorDia(dataSelecionada, loteriasLista) {
        const diaSemana = dayjs(dataSelecionada).day();
        const campoDia = mapDiaSemana[diaSemana];

        const loteriasFiltradas = loteriasLista.filter(el => el[campoDia] === true);
        const opcaoTodas = {value: 'todas', label: 'Todas'};
        const listaComTodas = [opcaoTodas, ...loteriasFiltradas];

        if (loteriasFiltradas.length > 0) {
            setLoteria(loteriasFiltradas[0]);
        } else {
            setLoteria(null);
        }
        setLoterias(listaComTodas);
    }

    useEffect(() => {
        http.get('/bancas/minha-banca')
            .then(res => {
                const banca = res.data.data;
                const ehOrigem = !!banca?.descarga_banca_id;
                const ehDestino = !!banca?.is_descarga_destino;
                if (!ehOrigem && !ehDestino) {
                    setRedirectTo('/descarga');
                    return;
                }
                setEhOrigem(ehOrigem);
                setEhDestino(ehDestino);
                if (!ehOrigem && ehDestino) {
                    setActiveTab('recebidas');
                }
            })
            .catch(() => setRedirectTo('/descarga'));
    }, []);

    useEffect(() => {
        requestLoterias();
    }, []);

    // Filtra loterias quando a data mudar ou quando carregar as loterias
    useEffect(() => {
        if (todasLoterias.length > 0) {
            filtrarLoteriasPorDia(data, todasLoterias);
        }
    }, [data, todasLoterias]);

    useEffect(() => {
        setDataBRL(dayjs(data).format('DD/MM/YYYY'));
    }, [data]);

    async function buscarRelatorio() {
        if (!loteria) {
            alerta({success: false, message: 'Selecione uma loteria'});
            return;
        }

        try {
            setLoading(true);
            setHasNoResult(false);
            setSumario(null);
            setRelatorio([]);

            if (loteria.value === 'todas') {
                const response = await http.get('/descargas/relatorio-sumario', {
                    params: {data: data},
                });

                const {itens, total: totalSumario} = response.data.data;

                setSumario({itens, total: totalSumario});
                setLoading(false);

                if (itens.length === 0) {
                    setHasNoResult(true);
                }
                return;
            }

            const response = await http.get('/descargas/relatorio', {
                params: {
                    loteria_id: loteria.value,
                    data: data,
                },
            });

            const {pendentes, gerados, resumo, banca} = response.data.data;

            setBancaInfo(banca);

            setRelatorio([
                ...pendentes.itens.map(item => ({...item, status: 'pendente'})),
                ...gerados.itens.map(item => ({...item, status: 'gerado'}))
            ]);
            setTotalGerado(resumo.total_gerado);
            setTotalPendente(resumo.total_pendente);
            setLoading(false);

            if (pendentes.itens.length === 0 && gerados.itens.length === 0) {
                setHasNoResult(true);
            }
        } catch (e) {
            setLoading(false);
            alerta(e.response?.data)
        }
    }

    async function buscarHistorico() {
        try {
            setLoading(true);
            setHasNoResult(false);

            const response = await http.get('/descargas/historico', {
                params: {
                    data_inicio: data,
                    data_fim: data,
                },
            });

            const {enviadas, recebidas} = response.data.data;

            setHistorico([
                ...enviadas.itens.map(item => ({...item, tipo: 'enviada'})),
                ...recebidas.itens.map(item => ({...item, tipo: 'recebida'}))
            ]);
            setLoading(false);

            if (enviadas.itens.length === 0 && recebidas.itens.length === 0) {
                setHasNoResult(true);
            }
        } catch (e) {
            setLoading(false);
            alerta(e.response?.data)
        }
    }

    async function gerarDescarga() {
        if (!loteria) {
            alerta({success: false, message: 'Selecione uma loteria'});
            return;
        }

        const pendentes = relatorio.filter(item => item.status === 'pendente');

        if (pendentes.length === 0) {
            alerta({success: false, message: 'Nenhuma descarga pendente para gerar'});
            return;
        }

        try {
            setLoadingGerar(true);

            const response = await http.post('/descargas/gerar', {
                loteria_id: loteria.value,
                data: data,
            });

            alerta(response.data);
            setLoadingGerar(false);

            // Recarrega o relatório
            buscarRelatorio();
        } catch (e) {
            setLoadingGerar(false);
            alerta(e.response?.data)
        }
    }

    function downloadPdf(blob, nome) {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', nome);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    async function enviarPdf() {
        if (!loteria || loteria.value === 'todas') {
            alerta({success: false, message: 'Selecione uma loteria específica para gerar o PDF'});
            return;
        }

        try {
            setLoading(true);

            const response = await http({
                url: '/descargas/baixar',
                method: 'GET',
                responseType: 'blob',
                params: { loteria: loteria.value, data },
            });

            const nome = `descarga-${loteria.label}-${data}.pdf`;
            const file = new File([response.data], nome, { type: 'application/pdf' });

            if (navigator.canShare && navigator.canShare({ files: [file] })) {
                try {
                    await navigator.share({
                        files: [file],
                        title: `Descarga - ${loteria.label}`,
                        text: `Descarga do dia ${dataBRL}`,
                    });
                } catch (shareError) {
                    if (shareError.name !== 'AbortError') {
                        downloadPdf(response.data, nome);
                    }
                }
            } else {
                downloadPdf(response.data, nome);
            }

            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    }

    async function buscarRecebidas() {
        try {
            setLoadingRecebidas(true);
            const params = {
                data_inicio: dataInicioRecebidas,
                data_fim: dataFimRecebidas,
            };
            if (loteriaFiltroRecebidas) params.loteria_id = loteriaFiltroRecebidas;
            if (bancaOrigemFiltroRecebidas) params.banca_origem_id = bancaOrigemFiltroRecebidas;

            const response = await http.get('/descargas/historico', { params });
            const dados = response.data.data?.recebidas ?? {itens: [], total: '0,00', quantidade: 0};
            setRecebidas(dados);
            setLoteriasRecebidas(dados.filtros?.loterias ?? []);
            setBancasOrigemRecebidas(dados.filtros?.bancas_origem ?? []);
        } catch (e) {
            alerta(e.response?.data);
        } finally {
            setLoadingRecebidas(false);
        }
    }

    async function enviarPdfRecebidas() {
        try {
            setLoadingRecebidas(true);
            const params = { data_inicio: dataInicioRecebidas, data_fim: dataFimRecebidas };
            if (loteriaFiltroRecebidas) params.loteria_id = loteriaFiltroRecebidas;
            if (bancaOrigemFiltroRecebidas) params.banca_origem_id = bancaOrigemFiltroRecebidas;

            const response = await http({
                url: '/descargas/recebidas/pdf',
                method: 'GET',
                responseType: 'blob',
                params,
            });
            const nome = `descargas-recebidas-${dataInicioRecebidas}-a-${dataFimRecebidas}.pdf`;
            const file = new File([response.data], nome, { type: 'application/pdf' });

            if (navigator.canShare && navigator.canShare({ files: [file] })) {
                try {
                    await navigator.share({
                        files: [file],
                        title: 'Descargas Recebidas',
                        text: `Descargas recebidas de ${dataInicioRecebidas} a ${dataFimRecebidas}`,
                    });
                } catch (shareError) {
                    if (shareError.name !== 'AbortError') {
                        downloadPdf(response.data, nome);
                    }
                }
            } else {
                downloadPdf(response.data, nome);
            }
        } catch (e) {
            alerta(e.response?.data);
        } finally {
            setLoadingRecebidas(false);
        }
    }

    function handleBuscar() {
        if (activeTab === 'relatorio') {
            buscarRelatorio();
        } else {
            buscarHistorico();
        }
    }

    if (redirectTo) {
        return <Redirect to={redirectTo} />;
    }

    return (
        <>
            <div className='titulo-principal'>Descarga</div>

            <div className={styles.tabs}>
                <button
                    className={`${styles.tab} ${activeTab === 'valores' ? styles.tabActive : ''}`}
                    onClick={() => setActiveTab('valores')}
                >
                    Valores da Descarga
                </button>
                <button
                    className={`${styles.tab} ${activeTab === 'relatorio' ? styles.tabActive : ''}`}
                    onClick={() => setActiveTab('relatorio')}
                >
                    Enviadas
                </button>
                <button
                    className={`${styles.tab} ${activeTab === 'historico' ? styles.tabActive : ''}`}
                    onClick={() => setActiveTab('historico')}
                >
                    Histórico
                </button>
                {ehDestino && (
                    <button
                        className={`${styles.tab} ${activeTab === 'recebidas' ? styles.tabActive : ''}`}
                        onClick={() => { setActiveTab('recebidas'); buscarRecebidas(); }}
                    >
                        Recebidas
                    </button>
                )}
            </div>

            {(activeTab === 'relatorio' || activeTab === 'historico') && <div className='d-flex tres-colunas conteudo-principal'>
                <input
                    required
                    type='date'
                    onChange={(event) => {
                        setData(event.target.value);
                        setHasNoResult(false);
                        setRelatorio([]);
                        setHistorico([]);
                        setSumario(null);
                    }}
                    className='form-control'
                    value={data}
                />

                {activeTab === 'relatorio' && (
                    <Select
                        label='Single select'
                        placeholder='Extração'
                        options={loterias}
                        value={loteria}
                        onChange={(event) => {
                            setLoteria(event);
                            setHasNoResult(false);
                            setRelatorio([]);
                            setSumario(null);
                        }}
                        theme={(theme) => ({
                            ...theme,
                            borderRadius: 0,
                        })}
                    />
                )}

                <button
                    style={{height: '38px'}}
                    type='submit'
                    className='btn btn-primary'
                    onClick={handleBuscar}
                    disabled={loading}
                >
                    {loading ? 'Buscando...' : 'Buscar'}
                </button>
            </div>}

            {loading && <div className='loader'/>}

            {/* Relatório Sumário (Todas) */}
            {!loading && activeTab === 'relatorio' && sumario && sumario.itens.length > 0 && (
                <div className={styles.containerTitle}>
                    <div style={{marginTop: '13px'}} className='d-flex duas-colunas'>
                        <div className={styles.title}><h4>Todas as Loterias — {dataBRL}</h4></div>
                    </div>

                    {/* Card de total destacado */}
                    <div style={{
                        background: '#1ab394', color: '#fff',
                        borderRadius: '8px', padding: '16px 24px',
                        display: 'inline-flex', alignItems: 'center', gap: '12px',
                        margin: '12px 0', boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                    }}>
                        <i className="fa fa-balance-scale" style={{fontSize: '22px'}} />
                        <div>
                            <div style={{fontSize: '12px', opacity: 0.85, textTransform: 'uppercase', letterSpacing: '0.5px'}}>Total Geral a Descarregar</div>
                            <div style={{fontSize: '24px', fontWeight: 700}}>R$ {sumario.total}</div>
                        </div>
                    </div>

                    <table className='table m-t'>
                        <thead>
                        <tr>
                            <th>Loteria</th>
                            <th>Quantidade</th>
                            <th>Valor Total</th>
                            <th>Situação / Motivo</th>
                        </tr>
                        </thead>
                        <tbody>
                        {sumario.itens.map((item, index) => (
                            <tr key={index} className={item.motivo ? styles.rowPendente : ''}>
                                <td><b>{item.loteria_nome}</b></td>
                                <td>{item.quantidade}</td>
                                <td>R$ {item.valor_total}</td>
                                <td>
                                    {item.motivo
                                        ? <span className={`${styles.badge} ${styles.badgeErro}`} title={item.motivo}>{item.motivo}</span>
                                        : <span className={`${styles.badge} ${styles.badgeGerado}`}>Pronto para gerar</span>
                                    }
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Relatório Tab */}
            {!loading && activeTab === 'relatorio' && relatorio.length > 0 && (
                <>
                    <div className={styles.containerTitle}>
                        <div
                            style={{marginTop: '13px'}}
                            className='d-flex duas-colunas'
                        >
                            <div className={styles.title}>
                                <h4>{loteria?.label}</h4>
                            </div>
                            <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                                <h4 style={{margin: 0}}>{dataBRL}</h4>
                                <button className='btn btn-success btn-sm' onClick={enviarPdf} disabled={loading}>
                                    <i className='fa fa-file-pdf-o' /> Enviar PDF
                                </button>
                            </div>
                        </div>

                        <div style={{padding: '8px 10px 0'}}>
                            <input
                                type='text'
                                inputMode='numeric'
                                className='form-control'
                                placeholder='Buscar por palpite (ex: 1554)'
                                value={filtroPalpite}
                                onChange={(e) => setFiltroPalpite(e.target.value.replace(/\D/g, ''))}
                                style={{maxWidth: 280}}
                            />
                        </div>

                        <table className='table m-t'>
                            <thead>
                            <tr>
                                <th>Status</th>
                                <th>Modalidade</th>
                                <th>Palpite</th>
                                <th>Sorteio</th>
                                <th>Valor</th>
                                {bancaInfo?.motivo && <th>Motivo</th>}
                            </tr>
                            </thead>
                            <tbody>
                            {aplicarFiltroEOrdenar(relatorio).map((item, index) => {
                                const isPendente = item.status === 'pendente';
                                return (
                                    <tr key={index} className={item.status === 'gerado' ? styles.rowGerado : styles.rowPendente}>
                                        <td>
                                            <span className={`${styles.badge} ${item.status === 'gerado' ? styles.badgeGerado : styles.badgePendente}`}>
                                                {item.status === 'gerado' ? 'Gerado' : 'Pendente'}
                                            </span>
                                        </td>
                                        <td>{item.modalidade}</td>
                                        <td>{item.numero}</td>
                                        <td>{item.sorteio}</td>
                                        <td>R$ {item.valor}</td>
                                        {bancaInfo?.motivo && (
                                            <td>
                                                {isPendente
                                                    ? <span className={`${styles.badge} ${styles.badgeErro}`}>{bancaInfo.motivo}</span>
                                                    : <span style={{color:'#aaa', fontSize:'12px'}}>—</span>
                                                }
                                            </td>
                                        )}
                                    </tr>
                                );
                            })}
                            </tbody>
                            <tfoot>
                            <tr>
                                <td colSpan={bancaInfo?.motivo ? 5 : 4}>
                                    <b>Total gerado:</b>
                                </td>
                                <td>
                                    <b>R$ {totalGerado}</b>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={bancaInfo?.motivo ? 5 : 4}>
                                    <b>Total pendente:</b>
                                </td>
                                <td>
                                    <b>R$ {totalPendente}</b>
                                </td>
                            </tr>
                            </tfoot>
                        </table>

                        {/* {bancaInfo && bancaInfo.loteria_destino_existe && relatorio.filter(item => item.status === 'pendente').length > 0 && (
                            <div className={styles.actionButtons}>
                                <button
                                    className='btn btn-success'
                                    onClick={gerarDescarga}
                                    disabled={loadingGerar}
                                >
                                    {loadingGerar ? 'Gerando...' : 'Gerar Descarga'}
                                </button>
                            </div>
                        )} */}
                    </div>
                </>
            )}

            {/* Histórico Tab */}
            {!loading && activeTab === 'historico' && historico.length > 0 && (
                <div className={styles.containerTitle}>
                    <div style={{marginTop: '13px', marginLeft: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingRight: '10px'}}>
                        <h4 style={{margin: 0}}>Histórico - {dataBRL}</h4>
                        <h4 style={{margin: 0}}>
                            Total: R$ {(() => {
                                const total = historico.reduce((acc, item) => {
                                    const v = parseFloat(String(item.valor ?? '0').replace(/\./g, '').replace(',', '.')) || 0;
                                    return acc + v;
                                }, 0);
                                return total.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                            })()}
                        </h4>
                    </div>

                    <div style={{padding: '8px 10px 0'}}>
                        <input
                            type='text'
                            inputMode='numeric'
                            className='form-control'
                            placeholder='Buscar por palpite (ex: 1554)'
                            value={filtroPalpite}
                            onChange={(e) => setFiltroPalpite(e.target.value.replace(/\D/g, ''))}
                            style={{maxWidth: 280}}
                        />
                    </div>

                    <table className='table m-t'>
                        <thead>
                        <tr>
                            <th>Tipo</th>
                            <th>Banca</th>
                            <th>Loteria</th>
                            <th>Modalidade</th>
                            <th>Número</th>
                            <th>Sorteio</th>
                            <th>Valor</th>
                            <th>Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        {aplicarFiltroEOrdenar(historico).map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td>
                                        <span className={`${styles.badge} ${item.tipo === 'enviada' ? styles.badgeEnviada : styles.badgeRecebida}`}>
                                            {item.tipo === 'enviada' ? 'Enviada' : 'Recebida'}
                                        </span>
                                    </td>
                                    <td>{item.tipo === 'enviada' ? item.banca_destino : item.banca_origem}</td>
                                    <td>{item.tipo === 'enviada' ? item.loteria : item.loteria}</td>
                                    <td>{item.modalidade}</td>
                                    <td>{item.numero}</td>
                                    <td>{item.sorteio_inicial} ao {item.sorteio_final}</td>
                                    <td>R$ {item.valor}</td>
                                    <td>
                                        <span className={`${styles.badge} ${item.status === 'gerado' ? styles.badgeGerado : styles.badgeErro}`}>
                                            {item.status}
                                        </span>
                                        {item.erro_mensagem && (
                                            <div style={{fontSize: '11px', color: 'red', marginTop: '4px'}}>
                                                {item.erro_mensagem}
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
            )}

            {hasNoResult && (activeTab === 'relatorio' || activeTab === 'historico') && (
                <div className={styles.noResult}>
                    <p>
                        {activeTab === 'relatorio'
                            ? <>Nenhuma descarga na loteria <b>{loteria?.label}</b> para o dia <b>{dataBRL}</b></>
                            : <>Nenhum histórico de descarga para o dia <b>{dataBRL}</b></>
                        }
                    </p>
                </div>
            )}

            {activeTab === 'valores' && <ValoresDescarga />}

            {activeTab === 'recebidas' && (
                <>
                    <div className='conteudo-principal'>
                        <div className='d-flex' style={{gap: 8, flexWrap: 'wrap'}}>
                            <input
                                type='date'
                                className='form-control'
                                style={{flex: 1, minWidth: 140}}
                                value={dataInicioRecebidas}
                                onChange={(e) => setDataInicioRecebidas(e.target.value)}
                            />
                            <input
                                type='date'
                                className='form-control'
                                style={{flex: 1, minWidth: 140}}
                                value={dataFimRecebidas}
                                onChange={(e) => setDataFimRecebidas(e.target.value)}
                            />
                            <select
                                className='form-control'
                                style={{flex: 1, minWidth: 140}}
                                value={loteriaFiltroRecebidas}
                                onChange={(e) => setLoteriaFiltroRecebidas(e.target.value)}
                            >
                                <option value=''>Todas as loterias</option>
                                {loteriasRecebidas.map(l => (
                                    <option key={l.id} value={l.id}>{l.nome}</option>
                                ))}
                            </select>
                            <select
                                className='form-control'
                                style={{flex: 1, minWidth: 140}}
                                value={bancaOrigemFiltroRecebidas}
                                onChange={(e) => setBancaOrigemFiltroRecebidas(e.target.value)}
                            >
                                <option value=''>Todas as bancas</option>
                                {bancasOrigemRecebidas.map(b => (
                                    <option key={b.id} value={b.id}>{b.codigo} - {b.nome}</option>
                                ))}
                            </select>
                            <button className='btn btn-info' onClick={buscarRecebidas} disabled={loadingRecebidas}>
                                Buscar
                            </button>
                        </div>
                    </div>

                    {loadingRecebidas && <div className='loader' />}

                    {!loadingRecebidas && recebidas.itens.length > 0 && (
                        <div className='conteudo-principal mt-2'>
                            <div className='d-flex justify-content-between align-items-center mb-2'>
                                <div>
                                    <b>Quantidade:</b> {recebidas.quantidade} | <b>Total:</b> R$ {recebidas.total}
                                </div>
                                <button className='btn btn-success' onClick={enviarPdfRecebidas}>
                                    <i className='fa fa-file-pdf-o' /> Enviar PDF
                                </button>
                            </div>
                            <input
                                type='text'
                                inputMode='numeric'
                                className='form-control mb-2'
                                placeholder='Buscar por palpite (ex: 1554)'
                                value={filtroPalpite}
                                onChange={(e) => setFiltroPalpite(e.target.value.replace(/\D/g, ''))}
                                style={{maxWidth: 280}}
                            />
                            <table className='table border'>
                                <thead>
                                    <tr>
                                        <th>Data</th>
                                        <th>Loteria</th>
                                        <th>Banca Origem</th>
                                        <th>Modalidade</th>
                                        <th>Número</th>
                                        <th>Sorteio</th>
                                        <th>Valor</th>
                                        <th>Gerado em</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {aplicarFiltroEOrdenar(recebidas.itens).map((item) => (
                                        <tr key={item.id}>
                                            <td>{item.data_resultado}</td>
                                            <td>{item.loteria}</td>
                                            <td>{item.banca_origem}</td>
                                            <td>{item.modalidade}</td>
                                            <td>{item.numero}</td>
                                            <td>{item.sorteio}</td>
                                            <td>R$ {item.valor}</td>
                                            <td>{item.gerado_em}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {!loadingRecebidas && recebidas.itens.length === 0 && (
                        <div className={styles.noResult}>
                            <p>Nenhuma descarga recebida no período</p>
                        </div>
                    )}
                </>
            )}
        </>
    );
}
